export const CALENDAR_UPDATE_DATE_REQUEST = 'CALENDAR_UPDATE_DATE_REQUEST';

export const CALENDAR_CHANGE_DATE = 'CALENDAR_CHANGE_DATE';

export const CALENDAR_SET_DATE = 'CALENDAR_SET_DATE';
